// crypto.randomUUID() só existe em "secure context" (HTTPS ou localhost). Ao
// servir o app por HTTP num IP de LAN (ex.: http://10.1.11.180:3200), o contexto
// NÃO é seguro e a função fica indefinida — toda mutação (que gera o
// Idempotency-Key em api.ts) quebraria com "crypto.randomUUID is not a function".
// crypto.getRandomValues continua disponível fora de secure context, então
// derivamos dele um UUID v4. Em HTTPS/localhost o nativo é mantido (no-op).
const c = globalThis.crypto as Crypto | undefined;
if (c && typeof c.randomUUID !== "function" && typeof c.getRandomValues === "function") {
  (c as unknown as { randomUUID: () => string }).randomUUID = () => {
    const b = c.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40; // versão 4
    b[8] = (b[8] & 0x3f) | 0x80; // variante RFC 4122
    const h = Array.from(b, (x) => x.toString(16).padStart(2, "0"));
    return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`;
  };
}
